export default __webpack_public_path__ + "static/media/LeF_Cool_Cat.ca6fcfa8.png";